import axios from "axios";
import {
  AlreadyBookedPitch,
  CreateOrder,
  Holidays,
  ItemDetails,
  venueListingPage,
  CouponCode,
  GetCountryTime,
} from "../common/api";
import { log } from "util";

export const handleCreateOrder = async (payload, token) => {
  try {
    const response = await axios.post(
      CreateOrder,
      {
        cart_data: payload,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${token}`,
        },
      }
    );

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to create order");
    }
  } catch (error) {
    throw new Error("Error creating order:", error);
  }
};

export const handleGetProductDetails = async (payload) => {
  try {
    const response = await axios.post(ItemDetails, payload);

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to get product details");
    }
  } catch (error) {
    throw new Error("Error getiing product details", error);
  }
};

export const getAlreaduBookedPitches = async (payload) => {
  try {
    const response = await axios.post(AlreadyBookedPitch, payload);

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to get product details");
    }
  } catch (error) {
    throw new Error("Error getiing product details", error);
  }
};

export const getCountrytime = async (payload) => {
  try {
    const response = await axios.post(GetCountryTime, payload);

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to get product details");
    }
  } catch (error) {
    throw new Error("Error getiing product details", error);
  }
};

export const getHolidaylist = async (payload) => {
  try {
    const response = await axios.post(Holidays, payload);

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to get product details");
    }
  } catch (error) {
    throw new Error("Error getiing product details", error);
  }
};

export const getPitchData = async (payload) => {
  try {
    const response = await axios.get(venueListingPage + "/" + payload);

    if (response.status === 200) {
      return response;
    } else {
      throw new Error("Failed to get product details");
    }
  } catch (error) {
    throw new Error("Error getiing product details", error);
  }
};

export const validateCouponCode = async (Coupon, Amount, Quantity, bookingFor) => {
  const token = localStorage.getItem("token");
  //console.log("Token in validateCouponCode", token);
  // console.log("Request body for Coupon & Discount calculation", Amount, Coupon, Quantity); 
  try {
    const response = await axios.get(CouponCode, {
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        amount: Amount,
        quantity: Quantity, 
        coupon_name: Coupon,
        booking_for: bookingFor,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${token}`,
      },

    });

    if (response.status === 200) {
      //console.log(response.data, "response for coupon");
      
      return response;
    } else {
      throw new Error(response.data?.message?.message || "Failed to apply coupon");
    }
  } catch (error) {
    throw error;
  }
};